// anchor links for full page navigation
import { useState, useEffect } from 'react';
import { Menu, X, ArrowUp } from 'lucide-react';
import aravindImg from "src/images/aravind.jpg";
import hemaImg from "src/images/hema-pic.jpg"
import arunImg from "src/images/arun.jpg";
import guhanImg from "src/images/guhan.jpg";
import hariniImg from "src/images/harini.jpg";
import nithiyaImg from "src/images/Nithiya.jpg";
import priyadharshiniImg from "src/images/priyadharshini.jpg";
import suyashImg from "src/images/suyash.jpg";
import magesImg from "src/images/mages.jpg";
import kamesImg from "src/images/kames.png";
import jithImg from "src/images/jithesh.jpg";
import pavithraImg from "src/images/pavithra.jpg";
import yasinImg from "src/images/yasin.jpg";
import vikasImg from "src/images/vikas.jpg";
import logo from "src/images/logo.png";

const teamMembers = [
  {
    id: 1,
    name: 'Pavithra R',
    role: 'Human Resources',
    image: pavithraImg,
    info: 'HR professional with strong software development skills who bridges people, processes, and technology.'
  },
  {
    id: 2,
    name: 'Aravind M',
    role: 'Python Developer',
    image: aravindImg,
    info: 'Enjoys crafting intelligent systems that make work faster and smarter.'
  },
  {
    id: 3,
    name: 'Hemapriya RC',
    role: 'UI/UX Designer',
    image: hemaImg,
    info: 'Turning ideas into intuitive interfaces and efficient systems with creativity and logic.'
  },
  {
    id: 4,
    name: 'Arun Nehru S',
    role: 'Java Developer',
    image: arunImg,
    info: 'A Java-driven problem solver who loves turning ideas into code — building real projects that blend logic and creativity.'
  },
  {
    id: 5,
    name: 'Nithiya B',
    role: 'Workflow & Operations Engineer',
    image: nithiyaImg,
    info: 'Enjoys engineering efficient workflows and management strategies for smooth, productive operations.'
  },
  {
    id: 6,
    name: 'Harini S',
    role: 'Creative Technologist',
    image: hariniImg,
    info: 'Blends creativity and curiosity beautifully, making every idea come alive.'
  },
  {
    id: 7,
    name: 'Mageswaran B',
    role: 'Robotics Engineer',
    image: magesImg,
    info: 'Robotics enthusiast with hands-on experience in building intelligent hardware systems.'
  },
  {
    id: 8,
    name: 'MV Priyadharshini',
    role: 'Creative Explorer',
    image: priyadharshiniImg,
    info: 'Finds joy in learning, imagining, building, and constantly exploring new creative paths.'
  },
  {
    id: 9,
    name: 'Guhan S',
    role: 'Smart Tools Engineer',
    image: guhanImg,
    info: 'Loves developing smart tools that make everyday work smoother and quicker.'
  },
  {
    id: 10,
    name: 'Suyash B',
    role: 'DevOps & AI Engineer',
    image: suyashImg,
    info: 'An aspiring DevOps and AI Engineer who seeks to learn about building and managing AI systems.'
  },
  {
    id: 11,
    name: 'Kameshvaran M',
    role: 'Gen AI Engineer',
    image: kamesImg,
    info: 'Always ready to take on challenges and push beyond limits.'
  },
  {
    id: 12,
    name: 'Jitheshvar M',
    role: 'Data Analyst',
    image: jithImg,
    info: 'Enjoys exploring practical applications of emerging technologies and developing projects that solve real-world problems.'
  },
  {
    id: 13,
    name: 'Yasin S',
    role: 'Data Analyst',
    image: yasinImg,
    info: 'Fearless in facing challenges and determined to exceed every limit.'
  },
  // {
  //   id: 14,
  //   name: 'Vikash Raaj S',
  //   role: 'Brand Growth & Social Media Strategist',
  //   image: vikasImg,
  //   info: 'Building impactful communication frameworks across social platforms to support long-term growth and engagement.'
  // }
];


const Team = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showFloating, setShowFloating] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowFloating(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      {/* Header */}
      <header className="header">
        <nav className="nav-container">
          <a href="/" className="logo" data-testid="logo-link">
            <img src={logo} alt="PK Placement Services Logo" className="logo-img" />
            <span>PK Placement Services</span>
          </a>
          <ul className="nav-links">
            <li><a href="/" data-testid="nav-home">Home</a></li>
            <li><a href="/" data-testid="nav-courses">Contact</a></li>
            <li><a href="/courses" data-testid="nav-courses">Courses</a></li>
          </ul>
          <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle mobile menu"
          >
            {mobileMenuOpen ? <X /> : <Menu />}
          </button>
          {mobileMenuOpen && (
            <div className="mobile-nav active">
              <ul>
                <li><a href="/" onClick={() => setMobileMenuOpen(false)}>Home</a></li>
                <li><a href="/" onClick={() => setMobileMenuOpen(false)}>Contact</a></li>
                <li><a href="/courses" onClick={() => setMobileMenuOpen(false)}>Courses</a></li>
              </ul>
            </div>
          )}
        </nav>
      </header>

      {/* Team Section */}
      <section className="section" style={{ paddingTop: '8rem' }} data-testid="team-section">
        <h2 className="section-title" data-testid="team-title">Our Team</h2>
        <div className="team-grid">
          {teamMembers.map((member) => (
            <div key={member.id} className="team-card" data-testid={`team-card-${member.id}`}>
              <div className="team-photo-container">
                <img
                  src={member.image}
                  alt={member.name}
                  className="team-photo"
                  data-testid={`team-photo-${member.id}`}
                />
              </div>
              <div className="team-info">
                <h3 data-testid={`team-name-${member.id}`}>{member.name}</h3>
                <p className="role" data-testid={`team-role-${member.id}`}>{member.role}</p>
                <p data-testid={`team-info-${member.id}`}>{member.info}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer className="footer" data-testid="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Quick Links</h4>
            <div className="flex">
              <ul className="footer-links flex flex-col items-start">
                <li><a href="/">Home</a></li>
                <li><a href="/courses">Courses</a></li>
                {/* <li><a href="/terms-and-conditions">Terms & Conditions</a></li> */}
              </ul>


              <ul className="footer-links px-10 flex flex-col items-start">
                <li><a href="/">Contact</a></li>
              </ul>
            </div>
          </div>

          <div className="footer-section">
            <h4>Connect With Us</h4>
            <div className="social-links flex flex-col">
              {/* WhatsApp */}
              <div className="flex items-center">
                <a
                  href="https://wa.me/+918056175066"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="social-whatsapp"
                >
                  <i className="fab fa-whatsapp"></i>
                </a>
                <span className='px-2 cursor-pointer' onClick={() => window.open("https://wa.me/+918056175066", "_blank")}>+91 80561 75066</span>
              </div>
              {/* Email */}
              <div className="flex items-center">
                <a
                  href="mailto:forpkqueries@gmail.com"
                  rel="noopener noreferrer"
                  data-testid="social-email"
                >
                  <i className="fas fa-envelope"></i>
                </a>
                <span className='px-2 cursor-pointer' onClick={() => window.open("mailto:forpkqueries@gmail.com", "_blank")}>forpkqueries@gmail.com</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 PK Placement Services. All rights reserved.</p>
        </div>
      </footer>

      {/* Floating Button */}
      {showFloating && (
        <button
          className="floating-btt-btn"
          data-testid="floating-btt-btn"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="Back to Top"
        >
          <ArrowUp className="btt-icon" />
        </button>
      )}
    </div>
  );
};

export default Team;